<template>
    <div>
        <div class="tableHeight" v-loading="loading">
            <el-table :data="data.tableData" border :height="height" :class="iframe ? 'iframeTableHeight' : ''" @selection-change="handleSelectionChange"
            @current-change="handleCurrentChanges">
                <template v-for="(column, index) in columns">
                    <el-table-column
                        :fixed='column.fixed'
                        v-if="column.type === 'index' || column.type === 'selection'"
                        :type="column.type"
                        :label="column.title ? column.title : ''"
                        :key="index"
                        :width="columns.width ? columns.width : 55"
                        :align="column.align ? column.align : 'left'"
                    >
                    </el-table-column>
                    <!-- 操作列/自定义列 -->
                    <el-table-column
                        v-else-if="column.slot"
                        :prop="column.dataIndex ? column.dataIndex : ''"
                        :fixed="column.fixed ? column.fixed : null"
                        :key="index"
                        :label="column.title ? column.title : ''"
                        :width="column.width ? column.width : null"
                        :min-width="column.minWidth ? column.minWidth : null"
                        :show-overflow-tooltip="column.showTooltip ? column.showTooltip : true"
                        :sortable="column.sortable ? column.sortable : false"
                        :align="column.align ? column.align : 'left'"
                    >
                        <template slot-scope="scope">
                            <slot :name="column.slot" :data="scope.row"></slot>
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-else
                        :prop="column.dataIndex ? column.dataIndex : ''"
                        :label="column.title ? column.title : ''"
                        :key="index"
                        :show-overflow-tooltip="column.showTooltip ? column.showTooltip : true"
                        :sortable="column.sortable ? column.sortable : false"
                        :width="column.width ? column.width : null"
                        :min-width="column.minWidth ? column.minWidth : null"
                        :formatter="column.tableFormatter ? column.tableFormatter : null"
                        :class-name="column.className ? column.className : null"
                        :align="column.align ? column.align : 'left'"
                    >
                    </el-table-column>
                </template>
            </el-table>
        </div>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="data.currentPage"
            :page-sizes="[15, 30, 50, 100, 200]"
            :page-size="data.paginate"
            layout="total, sizes, prev, pager, next, jumper"
            :total="data.total"
            background
        >
        </el-pagination>
    </div>
</template>
<script>
export default {
    props: {
        title:'',
        value: {},
        columns: {},
        maxHeight: {},
        // loading: {},
        searchHeight: '',
        url: {},
        method: {
            //初始化请求接口方式
            default() {
                return 'get';
            },
        },
    },
    components: {},
    data() {
        return {
            radioData:[],//单选数据
            loading: false,
            height: 0,
            iframe: false,
            data: {
                tableData: [], //查询列表table数据渲染
                paginate: 15, //每页条数
                total: 0, //总数
                currentPage: 1, //当前页
            },
            dxData:[],//多选数据
            resizeFlag:null,
        };
    },
    methods: {
        handleCurrentChanges(val){
            this.radioData = val
        },
        handleSelectionChange(val) {
            this.dxData = val
        },
        handleSizeChange(val) {
            this.data.paginate = val;
            this.getTableData();
            // this.$emit('handleSizeChange', val);
        },
        handleCurrentChange(val) {
            if (val === this.data.currentPage) {
                return;
            }
            this.data.currentPage = val;
            this.getTableData();
            // this.$emit('handleCurrentChange', val);
        },
        //获取表格数据
        getTableData() {
            let json = JSON.parse(JSON.stringify(this.value));
            json.resource_type = json.resource_type?json.resource_type.toString():'';
            json.paginate = this.data.paginate;
            json.currentPage = this.data.currentPage;
            let req;
            if (this.method == 'post') {
                req = this.$post(this.url.table, json);
            } else {
                req = this.$get(this.url.table, json);
            }
            this.loading = true;
            req.then(res => {
                //根据传入的url请求不同接口,查询不同的数据
                let data = res.ret.data;
                if (res.code == 0) {
                    this.loading = false;
                    this.data.tableData = data;
                    this.data.total = parseInt(res.ret.total); //因为后台返回是个字符串
                } else if (res.code != 0) {
                    this.loading = false;
                    this.data.tableData = [];
                    this.data.total = 0;
                    this.$message.error('数据返回错误');
                }
            });
        },
        //回调监听的方法
        Tablemodule() {
            this.data.currentPage = 1;
            this.getTableData();
          console.log(this.value);
        },
        whatScreen() {
            if(this.searchHeight){
                if (this.searchHeight > 100) {
                    this.height = document.body.clientHeight - 410 - Math.ceil(this.searchHeight - 90);
                    document.getElementsByClassName('tableHeight').height =
                        document.body.clientHeight - 410 - Math.ceil(this.searchHeight - 90);
                } else {
                    this.height = document.body.clientHeight - 360 - Math.ceil(this.searchHeight - 90);;
                    document.getElementsByClassName('tableHeight').height = document.body.clientHeight - 360 - Math.ceil(this.searchHeight - 90);
                }
            }
        },
    },
    created() {
        this.whatScreen();
    },
    mounted() {
        let _this = this;
        window.onresize = () => {
            if (_this.resizeFlag) {
                clearTimeout(_this.resizeFlag);
            }
        };
        _this.resizeFlag = setTimeout(() => {
            _this.whatScreen();
            _this.resizeFlag = null;
        }, 100);
    },
};
</script>
<style scoped>
</style>
